<template>
  <div>
    <div class="sa-mob-cont">
      <ValidationObserver
        ref="form"
        tag="div"
        class="sa-row"
        v-slot="{ handleSubmit }"
        @keyup.enter="handleSubmit(getData)"
      >
        <!-- <div class="sa-row"> -->
        <ValidationProvider
          tag="div"
          class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg12"
          rules="required"
          name="diagnosis"
          v-slot="{ errors }"
        >
          <div class="sa-form-group">
            <label>Diagnosis</label>
            <textarea
              v-model="diagnosis"
              class="sa-form-control sa-leave-control"
              id="diagnosis"
              name="diagnosis"
            ></textarea>
            <span class="sa-val-err">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
        <ValidationProvider
          tag="div"
          class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4"
          rules="required"
          name="number of days"
          v-slot="{ errors }"
        >
          <div class="sa-form-group">
            <label>Sick leave for</label>
            <!-- <input type="text" class="sa-form-control sa-leave-control" value="Issue Sick Leave" disabled v-model="daysText" /> -->
            <!-- <span class="sa-val-err">{{ errors[0] }}</span> -->
            <v-select
              :options="['1 day', '2 days', '3 days']"
              class="diagno-select"
              v-model="pInfo"
              id="numberOfDays"
              name="number of days"
            ></v-select>
          </div>
        </ValidationProvider>
        <ValidationProvider
          tag="div"
          class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4"
          rules="required"
          name="dates"
          v-slot="{ errors }"
        >
          <div class="sa-form-group">
            <label>Starting From <span class="sa-red-text">*</span></label>
            <i class="icon-calendar-gray sa-form-icon sa-sick-cal"></i>
            <vc-date-picker
              :min-date="new Date()"
              v-model="date"
              class="sa-mob-cal"
            >
              <input
                id="sel_date"
                v-model="sel_date"
                name="sel_date"
                slot-scope="{ inputProps, inputEvents, isDragging }"
                readonly
                :class="[
                  `sa-form-control sa-leave-control ${
                    isDragging ? 'text-gray-400' : 'text-gray-700'
                  }`,
                  { 'border-red-600': errorMessage },
                ]"
                v-bind="inputProps"
              />
            </vc-date-picker>
            <span class="sa-val-err">{{ errors[0] }}</span>
            <!-- <button type="button" class="" @click="date = null"><i class="icon-close"></i></button> -->
            <!-- <p class="" v-if="errorMessage">{{ errorMessage }}</p> -->
            <!-- <p v-else> We got it. Thanks! </p> -->
          </div>
        </ValidationProvider>
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
          <div class="sa-form-group">
            <button
              :disabled="disableButton"
              class="sa-btn sa-btn-large sa-btn-outline-primary sa-sick-leave"
              @click="handleSubmit(getData)"
            >
              Issue Sick Leave<img
                src="../../../../assets/img/loader.svg"
                alt="loader"
                class="sa-sign-loader"
                v-if="loader"
              />
            </button>
          </div>
        </div>
        <!-- </div> -->
      </ValidationObserver>
    </div>
    <!-- <div class="sa-ftr-btn">
        <button @click="$router.go(-1)" class="sa-btn sa-btn-large sa-btn-block-xs sa-btn-primary sa-fix-bot-btn">Continue</button>
    </div> -->
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
import moment from "moment";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Please provide {_field_}",
});
export default {
  watch: {
    date: {
      immediate: true,
      deep: true,
      handler() {
        let p = this.pInfo.charAt(0);
        this.days = p;
        this.end = moment(this.date).add(p, "day").format("YYYY-MM-DD");
        this.start = moment(this.date).format("YYYY-MM-DD");
        let st = moment(this.start).format("Do MMM YYYY");
        let et = moment(this.end).format("Do MMM YYYY");
        this.sel_date = this.date ? st + " " + "To" + " " + et : "";
      },
    },
    pInfo: {
      immediate: false,
      deep: true,
      handler() {
        let p = this.pInfo.charAt(0);
        this.days = p;
        if (!this.start) {
          this.end = moment(this.date).add(p, "day").format("YYYY-MM-DD");
          this.start = moment(this.date).format("YYYY-MM-DD");
        } else {
          this.end = moment(this.start).add(p, "day").format("YYYY-MM-DD");
        }
        let st = moment(this.start).format("Do MMM YYYY");
        let et = moment(this.end).format("Do MMM YYYY");
        this.sel_date = st + " " + "To" + " " + et;
      },
    },
  },
  data() {
    return {
      diagnosis: null,
      date: moment(),
      days: null,
      daysText: null,
      patDetails: null,
      loader: false,
      disableButton: false,
      pInfo: "1 day",
      sel_date: null,
      end: null,
      start: null,
      sickleave: {},
    };
  },
  methods: {
    getData(e) {
      let _self = this;
      _self.loader = true;
      _self.disableButton = true;
      let sobj = {
        apnt_id: this.$route.params.appid,
        diagnosis: this.diagnosis,
        days: (this.days == "") ? '1': this.days,
        vld_frm: this.start,
        vld_to: this.end,
      };
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/sickLeave/generate`,
          body: sobj,
        })
        .then((response) => {
          _self.loader = false;
          _self.disableButton = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Sick leave issued successfully",
              class: "sa-a-success",
            });
            _self.$router.go(-1);
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong. Please contact operations team",
              class: "sa-a-danger",
            });
          }
        });
    },
  },
  computed: {
    errorMessage() {
      if (!this.date) return "Date is required.";
      return "";
    },
  },
  created() {
    this.patDetails = JSON.parse(this.$localStorage.get("patDetails"));
  },
  mounted() {
    this.loader = false;
    let data = {
      apnt_id: this.$route.params.appid,
    };
    this.$store
      .dispatch("httpPost", {
        uri: `${pro_url}/sickLeave/details`,
        body: data,
      })
      .then((response) => {
        if (response && response.status == 1000) {
          this.sickleave = response.data;
          if (this.sickleave) {
            this.diagnosis = this.sickleave ? this.sickleave.diagnosis : "";
            this.days = this.sickleave.days;
            if (this.days == "1") {
              this.pInfo = this.days + " day";
            } else if (this.days == "2" || this.days == "3") {
              this.pInfo = this.days + " days";
            } else {
              this.pInfo = "1 day";
              let p = this.pInfo.charAt(0);
            }
            this.start = this.sickleave.vld_frm
              ? this.sickleave.vld_frm
              : moment(this.date).format("YYYY-MM-DD");
            this.end = this.sickleave.vld_to
              ? this.sickleave.vld_to
              : moment(this.date).add(p, "day").format("YYYY-MM-DD");
            let st = moment(this.start).format("Do MMM YYYY");
            let et = moment(this.end).format("Do MMM YYYY");
            this.sel_date = st + " " + "To" + " " + et;
            this.loader = false;
          }
        }
      });
  },
};
</script>
